(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sanctuary-simple-home"] && !Shopify.designMode) return;
  try {
    
function bindSanctuarySimple(){
  const root=document.getElementById('sr-simple-home');
  if(!root||root.dataset.bound)return;
  root.dataset.bound='true';
  function routeOriginalMenuLinks(){
    const view=location.hash==='#find-your-sanctuary'?'coffee-match':location.hash==='#sanctuary-coffee-club'?'subscriptions':'';
    if(!view)return false;
    const destination=new URL(location.href);
    destination.searchParams.set('view',view);
    destination.hash='';
    location.replace(destination.pathname+destination.search);
    return true;
  }
  if(routeOriginalMenuLinks())return;
  window.addEventListener('hashchange',routeOriginalMenuLinks);
  const button=root.querySelector('#sr-simple-add-box');
  if(!button)return;
  button.addEventListener('click',async()=>{
    if(button.disabled)return;
    const label=button.textContent;
    const status=root.querySelector('#sr-simple-cart-status');
    button.disabled=true;button.textContent=button.dataset.adding;status.textContent='';
    let tracking=Promise.resolve(false);
    try{if(typeof window.SanctuaryQuizTracking?.starterClick==='function')tracking=Promise.resolve(window.SanctuaryQuizTracking.starterClick()).catch(()=>false);}catch(error){}
    try{
      const items=[button.dataset.breakfast,button.dataset.espresso,button.dataset.trinity].map(id=>({id:Number(id),quantity:1}));
      const response=await fetch(button.dataset.cartAdd+'.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
      if(!response.ok)throw new Error('Cart error');
      status.textContent=button.dataset.added;
      await tracking;
      location.assign(button.dataset.cart);
    }catch(error){button.disabled=false;button.textContent=label;status.textContent=button.dataset.error;}
  });
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',bindSanctuarySimple);}else{bindSanctuarySimple();}
document.addEventListener('shopify:section:load',bindSanctuarySimple);

  } catch(e) { console.error(e); }
})();
})();
